// frontend/packs/resources-show.js

/* eslint-disable import/first, import/newline-after-import */

import { Application } from 'stimulus';
export const resourceShow = Application.start(); // eslint-disable-line import/prefer-default-export

import 'components/resources/show/resource-show-main/resource-show-main';
import 'components/resources/show/resource-show-main-col/resource-show-main-col';
import 'components/resources/show/resource-show-sidebar/resource-show-sidebar';
import 'components/resources/show/resource-show-preview/resource-show-preview';

import 'components/resources/show/free-attribution-slidedown/free-attribution-slidedown';
import(/* webpackPreload: true */ 'components/resources/show/license-selector-modal/license-selector-modal');
import(/* webpackPreload: true */ 'components/resources/show/download-popup/download-popup');
import(/* webpackPreload: true */ 'components/resources/show/resource-info-modal/resource-info-modal');
import(/* webpackPrefetch: true */ 'components/resources/show/post-purchase-banner/post-purchase-banner');

import 'components/resources/show/resource-related/resource-related';

import(/* webpackPreload: true */ 'components/license/license-info-modal/license-info-modal');
import(/* webpackPreload: true */ 'components/license/license-compare-modal/license-compare-modal');
import(/* webpackPreload: true */ 'components/license/license-attribution-modal/license-attribution-modal');

import 'components/partner/search/sponsored-results/sponsored-results';

import 'components/resources/show/resource-show-sidebar-pricing/resource-show-sidebar-pricing';

// start: split test download_limit_modal
import(/* webpackPreload: true */ 'components/resources/download-limit-form/download-limit-form');
// end: split test download_limit_modal

import ResourceShowMainController from 'components/resources/show/resource-show-main/resource-show-main-controller';
resourceShow.register('resource-show-main', ResourceShowMainController);

import ResourceFavoriteController from 'components/resources/show/resource-show-details/resource-favorite-controller';
resourceShow.register('resource-favorite', ResourceFavoriteController);

import ResourceMoreinfoController from 'components/resources/show/resource-show-details/resource-more-info-controller';
resourceShow.register('resource-more-info', ResourceMoreinfoController);

import ResourceShareController from 'components/resources/show/resource-show-details/resource-share-controller';
resourceShow.register('resource-share', ResourceShareController);

import ResourceShowPreviewController from 'components/resources/show/resource-show-preview/resource-show-preview-controller';
resourceShow.register('resource-show-preview', ResourceShowPreviewController);

import DownloadButtonController from 'components/resources/show/download-btn/download-btn-controller';
resourceShow.register('download-btn', DownloadButtonController);

import DownloadButtonPricingController from 'components/resources/show/resource-show-sidebar-pricing/download-btn/download-btn-pricing-controller';
resourceShow.register('download-btn-pricing', DownloadButtonPricingController);

import FreeAttributionSlidedownController from 'components/resources/show/free-attribution-slidedown/free-attribution-slidedown-controller';
resourceShow.register('free-attribution-slidedown', FreeAttributionSlidedownController);

import CopyLinkController from 'components/util/copy-link/copy-link-controller';
resourceShow.register('copy-link', CopyLinkController);

import PinterestShareController from 'components/resources/pinterest/pinterest-share-controller';
resourceShow.register('pinterest-share', PinterestShareController);

import('components/resources/show/license-selector-modal/license-selector-free-modal-controller')
  .then((controller) => {
    resourceShow.register('license-selector-free-modal', controller.default);
  });

import('components/resources/show/license-selector-modal/license-selector-credit-modal-controller')
  .then((controller) => {
    resourceShow.register('license-selector-credit-modal', controller.default);
  });

import('components/license/license-compare-modal/license-compare-modal-controller')
  .then((controller) => {
    resourceShow.register('license-compare-modal', controller.default);
  });

import EzCarouselController from 'components/util/ez-carousel/ez-carousel-controller';
resourceShow.register('ez-carousel', EzCarouselController);

import PostPurchaseBannerController from 'components/resources/show/post-purchase-banner/post-purchase-banner-controller';
resourceShow.register('post-purchase-banner', PostPurchaseBannerController);

import DownloadPopupController from 'components/resources/show/download-popup/download-popup-controller';
resourceShow.register('download-popup', DownloadPopupController);

import SocialButtonsController from 'components/util/social-sharing/social-buttons/social-buttons-controller';
resourceShow.register('social-buttons', SocialButtonsController);

import PartnerSponsoredResultsController from 'components/partner/search/sponsored-results/sponsored-results-controller';
resourceShow.register('partner-sponsored-results', PartnerSponsoredResultsController);

import SearchTagController from 'components/search/search-tags/search-tag-controller';
resourceShow.register('search-tag', SearchTagController);

import DownloadLimitJoinProModalController from 'components/sessions/download-limit-join-pro-modal-controller';
resourceShow.register('download-limit-join-pro-modal', DownloadLimitJoinProModalController);

import DownloadLimitUnconfirmedModalController from 'components/sessions/download-limit-unconfirmed-modal-controller';
resourceShow.register('download-limit-unconfirmed-modal', DownloadLimitUnconfirmedModalController);

import CollectionsModalFormController from 'components/collections/collections-modal/collections-modal-form-controller';
resourceShow.register('collections-modal-form', CollectionsModalFormController);

import CollectionsSearchFormController from 'components/collections/collections-search-form/collections-search-form-controller';
resourceShow.register('collections-search-form', CollectionsSearchFormController);

import CollectionsPrivacyControlController from 'components/collections/collections-privacy-control/collections-privacy-control-controller';
resourceShow.register('collections-privacy-control', CollectionsPrivacyControlController);

import CollectionsAlertController from 'components/collections/collections-alert/collections-alert-controller';
resourceShow.register('collections-alert', CollectionsAlertController);
